import { ClipboardList, Sparkles } from "lucide-react";
import Layout from "../components/Layout";
import DashboardCard from "../components/DashboardCard";
import { useAuth } from "../context/AuthContext";

export default function ResponsabileDashboard() {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.25em] text-blue-700 font-bold">Area Responsabile</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mt-2">
          Ciao, {user?.name?.split(" ")[0] || ""}
        </h1>
        <p className="text-slate-500 mt-3 max-w-2xl">
          Dirigi le tue competizioni o entra come giudice nelle valutazioni Dance Analysis.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
        <DashboardCard
          title="Le mie Competizioni"
          description="Direzione di una Competizione"
          icon={ClipboardList}
          to="/responsabile/competizioni"
          accent="blue"
          testId="resp-card-competizioni"
          delay={0}
        />
        <DashboardCard
          title="Dance Analysis"
          description="Le competizioni per le quali sono chiamato/a a giudicare"
          icon={Sparkles}
          to="/responsabile/dance-analysis"
          accent="indigo"
          testId="resp-card-dance-analysis"
          delay={120}
        />
      </div>
    </Layout>
  );
}
